import { observable } from 'mobx';

export type RemittanceDestinationAccountJson = {
  id?: number;
  bank_code: string;
  bank_name: string;
  branch_code: string;
  branch_name: string;
  account_type: 'savings' | 'checking' | 'deposit';
  account_number: string;
  account_holder: string;
};

class RemittanceDestinationAccount {
  private id?: number;

  @observable bankCode: string;
  @observable bankName: string;
  @observable branchCode: string;
  @observable branchName: string;
  @observable accountType: 'savings' | 'checking' | 'deposit';
  @observable accountNumber: string;
  @observable accountHolder: string;

  constructor(args: RemittanceDestinationAccountJson) {
    this.id = args.id;
    this.bankCode = args.bank_code;
    this.bankName = args.bank_name;
    this.branchCode = args.branch_code;
    this.branchName = args.branch_name;
    this.accountType = args.account_type;
    this.accountNumber = args.account_number;
    this.accountHolder = args.account_holder;
  }

  submitParams() {
    return {
      id: this.id,
      bank_code: this.bankCode,
      bank_name: this.bankName,
      branch_code: this.branchCode,
      branch_name: this.branchName,
      account_type: this.accountType,
      account_number: this.accountNumber,
      account_holder: this.accountHolder
    };
  }

  static build(): RemittanceDestinationAccount {
    return new RemittanceDestinationAccount({
      bank_code: '',
      bank_name: '',
      branch_code: '',
      branch_name: '',
      account_type: 'savings',
      account_number: '',
      account_holder: ''
    });
  }
}

export default RemittanceDestinationAccount;
